<template>
  <div class="caseAllList">
    <Personal-center-head>
      <div>我的病例</div>
      <template slot="revert">
        <div class="revert">返回</div>
      </template>
    </Personal-center-head>
    <div class="caseAllList-content">
    </div>
  </div>
</template> 

<script> 
import PersonalCenterHead from '../../../components/PersonalCenterHead/index'
export default {
  name: 'caseAllList',
  components: {
    PersonalCenterHead
  },
}

</script>
<style lang="less" scoped>
.caseAllList {
  padding: 50px 0;
  height: 98%;

  .caseAllList-content {
    width: 100%;
    height: 100%;
    margin-top: 23px;
    padding: 25px 20px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    background-color: #fff;
    overflow: hidden;
  }
}
</style>